module.exports = __webpack_public_path__ + "static/media/decoration-gray-top1.43e94c06.svg";